import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_patient_medical_test_consultation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_guid:fromDatatype.GuidDataFieldInterface;
  medical_test_hdr_guid: fromDatatype.GuidDataFieldInterface;
  test_status: fromDatatype.VarcharDatatypeInterface;
  test_result: fromDatatype.VarcharDatatypeInterface;
  test_category: fromDatatype.VarcharDatatypeInterface;
  test_notes: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_patient_medical_test_consultation_link_RowClass implements bl_hc_patient_medical_test_consultation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_guid:fromDatatype.GuidDataFieldInterface;
  medical_test_hdr_guid: fromDatatype.GuidDataFieldInterface;
  test_status: fromDatatype.VarcharDatatypeInterface;
  test_result: fromDatatype.VarcharDatatypeInterface;
  test_category: fromDatatype.VarcharDatatypeInterface;
  test_notes: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}